import styled from 'styled-components';

export const UCPMessageContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${props => props.$isUser ? 'flex-end' : 'flex-start'};
  margin-bottom: 16px;
`;

export const MessageWrapper = styled.div`
  max-width: 85%;
  padding: 12px 16px;
  border-radius: 12px;
  background-color: ${props => props.$isUser ? '#E3F2FD' : '#F5F5F5'};
  position: relative;
  
  ${props => props.$isTyping && `
    .streaming-message p:last-child::after {
      content: '▋';
      animation: blink 1s steps(2) infinite;
    }
    
    @keyframes blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0; }
    }
  `}
`;

export const MessageTimestamp = styled.div`
  font-size: 11px;
  color: #888;
  margin-bottom: 6px;
  font-weight: 500;
`;

export const MarkdownContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
  
  p {
    margin: 0 0 12px 0;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  h1, h2, h3, h4, h5, h6 {
    margin: 16px 0 8px 0;
    font-weight: 600;
    
    &:first-child {
      margin-top: 0;
    }
  }
  
  h1 { font-size: 1.5em; }
  h2 { font-size: 1.3em; }
  h3 { font-size: 1.1em; }
  
  ul, ol {
    margin: 8px 0;
    padding-left: 24px;
  }
  
  li {
    margin: 4px 0;
  }
  
  code {
    background-color: rgba(0, 0, 0, 0.06);
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
    font-size: 0.9em;
  }
  
  pre {
    background-color: #1e1e1e;
    color: #d4d4d4;
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 12px 0;
    
    code {
      background: none;
      padding: 0;
      color: inherit;
    }
  }
  
  blockquote {
    border-left: 3px solid #ddd;
    margin: 12px 0;
    padding-left: 12px;
    color: #666;
    font-style: italic;
  }
  
  a {
    color: #1976d2;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  strong {
    font-weight: 600;
  }
  
  em {
    font-style: italic;
  }
  
  hr {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 16px 0;
  }
  
  img {
    max-width: 100%;
    border-radius: 8px;
    margin: 8px 0;
  }
  
  /* Table styles */
  .markdown-table-container {
    overflow-x: auto;
    margin: 12px 0;
  }
  
  .markdown-table {
    border-collapse: collapse;
    width: 100%;
    font-size: 13px;
    border: 1px solid #e0e0e0;
  }
  
  .markdown-th,
  .markdown-td {
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    text-align: left;
  }
  
  .markdown-th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  
  .markdown-tr:hover {
    background-color: #fafafa;
  }
`;

export const MessageFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: ${props => props.$copied ? '#e8f5e9' : 'transparent'};
  border: 1px solid ${props => props.$copied ? '#4caf50' : '#ddd'};
  color: ${props => props.$copied ? '#4caf50' : '#666'};
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.$copied ? '#e8f5e9' : '#f5f5f5'};
    border-color: ${props => props.$copied ? '#4caf50' : '#bbb'};
  }
`;
